module.exports = __webpack_public_path__ + "static/img/7.650d8e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/7.png
// module id = 2hA9
// module chunks = 0